export * from './lib/infinity-multi-select.module';
